import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./DashboardCRUD";
import { dashboardSlice } from "./DashboardSlice";

const { actions } = dashboardSlice;

export const checkDashboardList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .callDashboardList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.dashboardListFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: callDashboardList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
